import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import InfiniteScroller from 'react-infinite-scroller';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import OrderCard from '../../components/order-card/order-card.component';
import NewOrderModal from '../../components/new-order-modal/new-order-modal.component';
import { OrderSortBy } from '../../enums';
import { isURLValid } from '../../utils/helpers/valid';
import { getOrders, getOrder } from '../../redux/thunks/orders';
import { setCurrentPage } from '../../redux/entities/orders';
import { useDebounce } from '../../utils/hooks/useDebounce';

const Orders = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [searchData, setSearchData] = useState({});
  const { orders, currentPage, limit, totalDocs } = useSelector(
    (state) => state.entities.orders
  );
  const [orderData, setOrderData] = useState(null);

  useEffect(() => {
    const { id } = params;
    const onSuccess = (data) => setOrderData(data);
    const onError = (error) => console.error(error);

    if (id) {
      dispatch(getOrder({ orderId: id, onSuccess, onError}));
    }
  }, [params]);

  const handleSortByChange = (e) => {
    if (!e.target.value || !e.target.value.length) {
      setSearchData((prev) => {
        const { sortBy, ...otherPrevData } = prev;
        return { ...otherPrevData };
      });
      return;
    }

    const foundOption = Object.entries(OrderSortBy).find(
      ([key, value]) => key === e.target.value
    );
    if (!foundOption) {
      setSearchData((prev) => {
        const { sortBy, ...otherPrevData } = prev;
        return { ...otherPrevData };
      });
      return;
    }

    setSearchData((prev) => ({ ...prev, sortBy: foundOption[0] }));
  };

  const handleDomainChange = (e) => {
    if (!e.target.value || !e.target.value.trim().length) {
      setSearchData((prev) => {
        const { domain, ...otherPrevData } = prev;
        return { ...otherPrevData };
      });
      return;
    }

    if (!isURLValid(e.target.value)) {
      setSearchData((prev) => {
        const { domain, ...otherPrevData } = prev;
        return { ...otherPrevData };
      });
      return;
    }

    setSearchData((prev) => ({ ...prev, domain: e.target.value.trim() }));
  };

  useEffect(() => {
    dispatch(
      getOrders({
        page: currentPage,
        limit,
        ...searchData,
      })
    );
  }, [currentPage, limit]);

  useDebounce(() => {
    dispatch(
      getOrders({
        page: currentPage,
        limit,
        ...searchData,
      })
    );
  }, [searchData], 500);

  useEffect(() => {
    dispatch(setCurrentPage(1));
  }, [searchData]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <Card>
        <Card.Body>
          <Card.Text
            style={{
              display: 'flex',
              gap: '1rem',
            }}
          >
            <Form.Control
              placeholder="דומיין"
              type="text"
              onChange={handleDomainChange}
            />
            <Form.Select onChange={handleSortByChange}>
              <option>מיין לפי</option>
              {Object.entries(OrderSortBy).map(([key, value]) => (
                <option key={key} value={key}>
                  {value}
                </option>
              ))}
            </Form.Select>
          </Card.Text>
        </Card.Body>
      </Card>

      <InfiniteScroller
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
        pageStart={1}
        loadMore={() => dispatch(setCurrentPage(currentPage + 1))}
        loader={
          <div className="loader" key={0}>
            טוען...
          </div>
        }
        hasMore={currentPage * limit < totalDocs}
      >
        {orders.map((orderItem) => (
          <OrderCard key={orderItem.id} {...orderItem} />
        ))}
      </InfiniteScroller>

      {orderData && <NewOrderModal
        show={orderData}
        onClose={() => setOrderData(null)}
        primaryDomain={orderData.domain}
        selectedBacklinks={orderData.backlinks}
        isDisabled={true}
        orderId={orderData.id}
      />}
    </div>
  );
};

export default Orders;
